














































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  ActivityLogsApi,
  ActivityLogsApiGetActivityLogByKeywordRequest,
} from "../../../apis";
import { DataOptions } from "vuetify";
import moment from "moment";

@Component({
  components: {},
})
export default class ActivityLogs extends Vue {
  dataActivityLogs = [];

  get HEADERS() {
    return [
      {
        text: this.$t("text.objectName"),
        value: "name",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
      },
      {
        text: this.$t("text.oldValue"),
        value: "oldValue",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
      },
      {
        text: this.$t("text.newValue"),
        value: "newValue",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
      },
      {
        text: this.$t("text.dateTime"),
        value: "updatedAt",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        width: 200,
      },
      {
        text: this.$t("text.eventInitiated"),
        value: "user.fullName",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        width: 200,
      },
    ];
  }

  pagingOption: DataOptions | null = null;
  totalRecord: number = 0;

  searchParam: any = {
    keyword: "",
  };

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  mounted() {}

  onPagingOption() {
    this.doSearch();
  }

  async doSearch() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const startDate = this.searchParam.startDate
      ? moment(this.searchParam.startDate, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const endDate = this.searchParam.endDate
      ? moment(this.searchParam.endDate, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      startDate: startDate,
      endDate: endDate,
      limit: this.pagingOption.itemsPerPage,
      page: this.pagingOption.page,
      orderBy: getValueOrUndefined(this.pagingOption.sortBy[0]),
      orderDesc: getValueOrUndefined(this.pagingOption.sortDesc[0]),
    } as ActivityLogsApiGetActivityLogByKeywordRequest;
    try {
      this.$util.showLoading();
      const res = await new ActivityLogsApi().getActivityLogByKeyword(body);
      this.dataActivityLogs = res.data.data;
      this.totalRecord = res.data.count;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
